"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeCase = exports.pascalCase = exports.capitalCase = exports.camelCase = exports.toDollars = exports.maskEmail = exports.generateRandomString = exports.changeObjectPropertyNameCasesInPlace = void 0;
const change_case_1 = require("change-case");
Object.defineProperty(exports, "camelCase", { enumerable: true, get: function () { return change_case_1.camelCase; } });
Object.defineProperty(exports, "capitalCase", { enumerable: true, get: function () { return change_case_1.capitalCase; } });
Object.defineProperty(exports, "pascalCase", { enumerable: true, get: function () { return change_case_1.pascalCase; } });
Object.defineProperty(exports, "snakeCase", { enumerable: true, get: function () { return change_case_1.snakeCase; } });
function changeObjectPropertyNameCasesInPlace(caseType, o) {
    Object.keys(o).forEach((propName) => {
        const newPropName = caseType === "camel" ?
            change_case_1.camelCase(propName) :
            change_case_1.snakeCase(propName);
        if (newPropName !== propName) {
            o[newPropName] = o[propName];
            delete o[propName];
        }
    });
    return o;
}
exports.changeObjectPropertyNameCasesInPlace = changeObjectPropertyNameCasesInPlace;
function generateRandomString(length, characters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz") {
    const chars = characters;
    const stringLength = length;
    let randomString = "";
    for (let i = 0; i < stringLength; i++) {
        const randomGenerate = Math.floor(Math.random() * chars.length);
        randomString += chars.substring(randomGenerate, randomGenerate + 1);
    }
    return randomString;
}
exports.generateRandomString = generateRandomString;
function maskEmail(email) {
    var _a;
    if (!email || email.length < 3) {
        return email;
    }
    const matchUsernamePart = "(?<usernameFirstChar>[^@])(?<usernameMiddleChars>[^@]*?)(?<usernameLastChar>[^@]?)";
    const matchMailServerPart = "(?<mailServerFirstChar>[^.])(?<mailServerMiddleChar>.*?)(?<mailServerLastChar>[^.]?)";
    const matchTopLevelDomainPart = "(?<topLevelDomain>\\.[^.]+)?";
    const reEmail = new RegExp(`^${matchUsernamePart}@${matchMailServerPart}${matchTopLevelDomainPart}$`);
    const matches = (_a = email.match(reEmail)) === null || _a === void 0 ? void 0 : _a.groups;
    if (matches) {
        const { usernameFirstChar, usernameMiddleChars, usernameLastChar, mailServerFirstChar, mailServerMiddleChar, mailServerLastChar, topLevelDomain } = matches;
        return [
            !usernameMiddleChars && !usernameLastChar ? "*" : usernameFirstChar,
            usernameMiddleChars ? "*".repeat(usernameMiddleChars.length) : "",
            usernameLastChar && !usernameMiddleChars ? "*" : usernameLastChar,
            "@",
            !mailServerMiddleChar && !mailServerLastChar ? "*" : mailServerFirstChar,
            mailServerMiddleChar ? "*".repeat(mailServerMiddleChar.length) : "",
            mailServerLastChar && !mailServerMiddleChar ? "*" : mailServerLastChar,
            topLevelDomain
        ].join("");
    }
    return email;
}
exports.maskEmail = maskEmail;
function toDollars(value) {
    let _value;
    if (typeof value === "string") {
        _value = parseInt(value, 10);
    }
    else {
        _value = value !== null && value !== void 0 ? value : 0;
    }
    return _value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}
exports.toDollars = toDollars;
//# sourceMappingURL=stringUtilities.js.map